import { delay, newsApi, } from '@/apis'



const news = {
  namespaced: true,
  state: {
    data: null,
    timer: null,
  },
  mutations: {
    setData(state, data) {
      state.data = data
    },
  },
  actions: {
    runTimer(content) {
      console.log('content.getters[', content.state.timer)
      if (content.state.timer == null) {
        content.dispatch('getData')
        content.state.timer = setInterval(() => {
          content.dispatch('getData')
        }, 5000)
      }
    },
    async getData(content) {
      const data = await newsApi.list()

      content.commit('setData', data.list)
    },
  },
  getters: {
    data: state => state.data,
  }
}

export default news